import { IUpsellBoxStatus, UpsellReferrer, UpSellTypeEnum } from './interfaces';
import { ICartData } from '../../projects/shopping-cart/cart-bridger-pay/interfaces';
import { UpsellType4 } from './upsell-types/upsell-type-4';
import { UpsellType2 } from './upsell-types/upsell-type-2';

export const getUpsellBoxStatus = (
    cartData: ICartData,
    referrer: UpsellReferrer
) : IUpsellBoxStatus => {

    if(!cartData ||
        !cartData?.cartItems?.length ||
        !cartData?.upsellRules?.length) {
        return {
            isVisible: false,
        };
    }

    switch (cartData.upsellTypeID) {
        case UpSellTypeEnum.TotalFixed: {
            const type4 = new UpsellType4(
                cartData.cartItems,
                cartData.upsellRules,
                cartData.upsellExcludedProducts,
                referrer,
                cartData.priceData?.totalUpsellDiscount ?? 0,
            );

            const result = type4.getUpsellTypeResult();
            if(!result?.isVisible) {
                return {
                    isVisible: false,
                };
            }

            return {
                isVisible: true,
                result,
            }
        }

        case UpSellTypeEnum.FixedPrice: {
            const type2 = new UpsellType2(
                cartData.cartItems,
                cartData.upsellRules,
                cartData.upsellExcludedProducts,
                referrer,
                cartData.priceData?.totalUpsellDiscount ?? 0,
            );

            const result = type2.getUpsellTypeResult();
            if(!result?.isVisible) {
                return {
                    isVisible: false,
                };
            }

            return {
                isVisible: true,
                result,
            }
        }
    }

    return {
        isVisible: false,
    };
};